import React from 'react';
import styled from 'styled-components';
import CopyButton from './CopyButton';

type GeneratedMessageProps = {
  message: string;
  onUpdate: () => void;
  showUpdateForm: boolean;
};

const Container = styled.div`
  margin-top: 10px;
  word-wrap: break-word;
`;

const MessageContainer = styled.div`
  background-color: #dae4fe;
  border-radius: 4px;
  padding: 25px 15px;
  margin-bottom: 5px;
  min-height: 50px;
  display: flex;
  align-items: center;
`;

const TextWrapper = styled.div`
  width: 100%;
`;

const UpdateButton = styled.button`
  font-size: 12px;
  font-weight: bold;
  text-transform: none;
  background-color: white;
  color: black;
  margin: 5px 5px 5px 0;
  padding: 5px 15px;
  border: 1px solid black;

  &:hover {
    background-color: #f9fafc;
    border-color: black;
  }
`;

const GeneratedMessage = ({ message, onUpdate, showUpdateForm }: GeneratedMessageProps) => {
  return (
    <Container>
      <MessageContainer>
        <TextWrapper>{message || 'Generating a response...'}</TextWrapper>
      </MessageContainer>
      {!showUpdateForm && message ? (
        <>
          <UpdateButton onClick={onUpdate}>Update</UpdateButton>
          <CopyButton text={message} />
        </>
      ) : (
        <div></div>
      )}
    </Container>
  );
};

export default GeneratedMessage;
